export class InvalidTokenError extends Error {
  constructor(type?: string) {
    super(`Invalid token ${type ?? ""}`);
  }
}
